import { createTemporaryId } from "../utils/model";

export class CallCohearingSession {
  readonly id: string = createTemporaryId();
  readonly takeoverAt?: Date;
  
  constructor(deriveFrom?: Partial<CallCohearingSession>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.takeoverAt) {
      this.takeoverAt = new Date(this.takeoverAt);
    }
  }
}